module.exports = __webpack_public_path__ + "img/chat_icon.3a10629f.svg";